const mutations = {
  _SET_DOCUMENT_INSPECTION_MODAL: 'SET_DOCUMENT_INSPECTION_MODAL',
};

export default {
  mutations,
};
